(() => {
  const itemsKey = 'family-gift-home-add-on-items';
  const errorKey = 'family-gift-home-add-on-error';
  const storedItems = sessionStorage.getItem(itemsKey);

  const showError = () => {
    const message = sessionStorage.getItem(errorKey);
    if (!message) return;

    sessionStorage.removeItem(errorKey);
    const notice = document.createElement('p');
    notice.className = 'add-on-cart__error';
    notice.setAttribute('role', 'alert');
    notice.textContent = message;
    document.querySelector('main')?.prepend(notice);
  };

  if (!storedItems) {
    showError();
    return;
  }

  sessionStorage.removeItem(itemsKey);

  let items;
  try {
    items = JSON.parse(storedItems).filter((item) => Number.isFinite(item.id) && item.quantity > 0);
  } catch (_) {
    return;
  }

  if (!items.length) return;

  fetch(window.routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ items }),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) throw new Error(response.description || response.message);
      window.location.reload();
    })
    .catch(() => {
      sessionStorage.setItem(errorKey, 'Your main product was added, but the selected add-on could not be added. Please try again.');
      window.location.reload();
    });
})();
